/* eslint-disable react/prop-types */
import React from 'react';
// components
import SkillsInfo from './components/SkillsInfo';
import PersonalInfo from './components/PersonalInfo';
import EducationInfo from './components/EducationInfo';
import LanguagesInfo from './components/LanguagesInfo';
import ExperienceInfo from './components/ExperienceInfo';
import AboutYourselfInfo from './components/AboutYourselfInfo';
import DriverLicenseInfo from './components/DriverLicenseInfo';

const CVDescription = ({ cv_id, cvDetails }) => {
  const {
    skills = [],
    languages = [],
    educations = [],
    experiences = [],
    about_yourself = '',
    driver_license = '',
  } = cvDetails;

  return (
    <>
      <div className='cvDescription'>
        <PersonalInfo cv_id={cv_id} cvDetails={cvDetails} />
        {experiences?.length > 0 && experiences[0]?.position && <ExperienceInfo cvDetails={cvDetails} />}
        {skills?.length > 0 && <SkillsInfo cvDetails={cvDetails} />}
        {educations?.length > 0 && educations[0]?.edu_type && <EducationInfo cvDetails={cvDetails} />}
        {languages?.length > 0 && languages[0]?.lng && <LanguagesInfo cvDetails={cvDetails} />}
        {about_yourself && about_yourself !== '<p><br></p>' && <AboutYourselfInfo cvDetails={cvDetails} />}
        {driver_license != 0 && <DriverLicenseInfo cvDetails={cvDetails} />}
      </div>
    </>
  );
};

export default CVDescription;
